import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from "@angular/router";
import { BreadcrumbService } from '../../../core/services/breadcrumb/breadcrumb.service';


@Component({
  selector: 'app-users',
  standalone: true,
  imports: [RouterOutlet
  ],
  templateUrl: './users.component.html',
  styleUrl: './users.component.css'
})
export class UsersComponent { }
